import { LoadingOutlined } from '@ant-design/icons'
export const antIcon = (
    <LoadingOutlined style={{ fontSize: 24, color: '#13023E' }} spin />
)
